<template>
  <loader :is-loading="isLoading">
    <div>
      <v-tabs
        active-class="primary--text"
        :height="FRI_TABS_HEIGHT + 20"
        :background-color="$vuetify.theme.themes[theme].background"
        v-model="period"
        grow
        show-arrows
      >
        <v-tab>
          <button-icon
            icon-text="24h"
            label="Sur 24 Heures"
            :active="period === 0"
            :badge="displayed[0] ? '!' : null"
          />
        </v-tab>
        <v-tab>
          <button-icon
            icon-text="15j"
            label="Sur 15 Jours"
            :active="period === 1"
            :badge="displayed[1] ? '!' : null"
          />
        </v-tab>
        <v-tab>
          <button-icon
            icon="mdi-account-details"
            label="Par Appelant"
            :active="period === 2"
            :badge="displayed[2] ? '!' : null"
          />
        </v-tab>
      </v-tabs>
      <v-tabs-items
        :style="{
          background: $vuetify.theme.themes[theme].background,
        }"
        v-model="period"
      >
        <v-tab-item>
          <div
            class="d-flex flex-wrap"
            style="max-height: 300px; overflow-y: auto;"
            v-if="data_24h.length > 1"
          >
            <div
              v-for="item in count_24h"
              :key="item.code"
              class="d-flex align-center flex-nowrap my-2"
            >
              <number-badge
                :label="item.name"
                :number="item.count"
                :value="detail && item.code === detail.code"
                @click="showDetail(item)"
              />
            </div>
          </div>
          <div v-else class="caption mt-2">
            Pas de données sur la période
          </div>
        </v-tab-item>
        <v-tab-item>
          <div v-if="data_15d.length > 1">
            <div
              class="d-flex flex-wrap"
              style="max-height: 300px; overflow-y: auto;"
            >
              <div
                v-for="item in sortedData_15d"
                :key="item.status"
                class="d-flex align-center flex-nowrap my-2"
              >
                <number-badge
                  :label="displayName(item)"
                  :number="item.list.length"
                  :value="
                    detail &&
                      item.rejected === detail.rejected &&
                      item.status === detail.status
                  "
                  @click="showDetail(item)"
                />
              </div>
            </div>
            <v-card
              rounded
              color="background"
              v-if="detail && (detail.status === '5' || detail.status === '9')"
            >
              <div class="d-flex flex-wrap">
                <div
                  v-for="req in expandedFinished"
                  :key="req.reason"
                  class="d-flex align-center flex-nowrap my-2"
                >
                  <number-badge
                    :label="displayName(req)"
                    :number="req.list.length"
                    :value="
                      expand.length &&
                        expand.some((item) => req.reason === item.reason)
                    "
                    @click="showExpand(req)"
                  />
                </div>
              </div>
            </v-card>
          </div>
          <div v-else class="caption mt-2">
            Pas de données sur la période
          </div>
        </v-tab-item>
        <v-tab-item>
          <div
            class="d-flex flex-wrap"
            style="max-height: 300px; overflow-y: auto;"
            v-if="customer_15d.length > 0"
          >
            <div
              v-for="item in customer_15d"
              :key="item.name"
              class="d-flex align-center flex-nowrap my-2"
            >
              <number-badge
                :label="item.name"
                :number="item.count"
                :value="detail && item.name === detail.name"
                @click="showDetail(item)"
              />
            </div>
          </div>
          <div v-else class="caption mt-2">
            Pas de données sur la période
          </div>
        </v-tab-item>
      </v-tabs-items>
      <div v-if="detail" class="info--text my-3 mt-2 ml-4">
        {{ tableTitle | capitalize }} :
      </div>
      <requests-recurrence-table
        class="mx-auto"
        v-if="detail"
        :data="tableData"
        :onlyClosed="this.period === 1"
      />
    </div>
  </loader>
</template>

<script>
import { generateMessage } from '@/utils/i18n';
import { mapGetters } from 'vuex';
import Loader from '@/components/widgets/Loader';
import ButtonIcon from '@/pages/FRI/ButtonIcon';
import FRI_TABS_HEIGHT from '@/pages/FRI/summaryPropertySheet.styles';
import { REQUEST_STATES } from '@/store/modules/requests/treated';
import { sortByReason } from '@/store/modules/properties/requests/customGetters';
import RequestsRecurrenceTable from './RequestRecurrenceTable';
import NumberBadge from './NumberBadge';

export default {
  name: 'PropertyRecurrence',
  components: { RequestsRecurrenceTable, Loader, NumberBadge, ButtonIcon },
  computed: {
    ...mapGetters({
      data_24h: 'properties/requests/last24hItems',
      count_24h: 'properties/requests/last24hFilteredItems',
      data_15d: 'properties/requests/last15dItems',
      sortedData_15d: 'properties/requests/last15dSortedItems',
      customer_15d: 'properties/requests/customersSortedItems',
      reasonsToBeContinued: 'requests/reasonsToBeContinued/items',
      isLoading: 'properties/requests/isLoadingItems',
      rejectionTypes: 'requests/rejectionTypes/items',
    }),
    theme() {
      return this.$vuetify.theme.dark ? 'dark' : 'light';
    },
    tableTitle() {
      return (
        this.detail &&
        `${
          this.period !== 1 ? this.detail.name : this.displayName(this.detail)
        } sur ${this.period === 0 ? '24 heures' : '15 jours'}`
      );
    },
    tableData() {
      if (this.detail) {
        if (this.period === 0) {
          return this.data_24h.filter(
            (request) => request.work_order_group_type_code === this.detail.code
          );
        }
        if (this.period === 1) {
          if (this.expand.length) {
            return this.expand.reduce((acc, item) => acc.concat(item.list), []);
          }
          return this.detail.list;
        }
        if (this.period === 2) {
          return this.data_15d.filter(
            (request) =>
              request.customer_name === this.detail.lastName &&
              request.customer_phone === this.detail.phone &&
              request.customer_civility === this.detail.civility
          );
        }
      }
      return [];
    },
    expandedFinished() {
      return (
        (this.detail.status === '5' || this.detail.status === '9') &&
        sortByReason(this.detail.list)
      );
    },
  },
  filters: {
    capitalize(text) {
      return text.charAt(0).toUpperCase() + text.slice(1);
    },
  },
  watch: {
    isLoading(value) {
      if (!value) {
        if (this.data_24h.length > 1) {
          this.period = 0;
          this.displayed = [
            false,
            this.data_15d.length > 1,
            this.customer_15d.length > 0,
          ];
        } else if (this.data_15d.length > 1) {
          this.period = 1;
          this.displayed = [false, false, this.customer_15d.length > 0];
        } else {
          this.period = 0;
          this.detail = null;
          this.displayed = [false, false, false];
        }
        this.refreshDetail(this.period);
      }
    },
    period(value) {
      this.refreshDetail(value);
    },
  },
  methods: {
    generateMessage,
    displayName(item) {
      if (item.rejected) {
        return 'Rejetée';
      }
      if (item.status) {
        const state = REQUEST_STATES.find(
          (status) => status.id === item.status
        );
        return (state && state.name) || 'Terminée';
      }
      const reason = this.reasonsToBeContinued.find(
        (reas) => reas.id === item.reason
      );
      return (reason && reason.short_name) || 'Terminée';
    },
    showDetail(item) {
      this.detail = item;
      this.expand = [];
    },
    showExpand(item) {
      if (this.expand.some((req) => req.reason === item.reason)) {
        this.expand = this.expand.filter((req) => req.reason !== item.reason);
      } else {
        this.expand.push(item);
      }
    },
    refreshDetail(value) {
      if (value === 0 && this.data_24h.length > 1) {
        [this.detail] = this.count_24h;
        this.displayed[0] = false;
      } else if (value === 1 && this.data_15d.length > 1) {
        [this.detail] = this.sortedData_15d;
        this.displayed[1] = false;
      } else if (value === 2 && this.customer_15d.length > 0) {
        [this.detail] = this.customer_15d;
        this.displayed[2] = false;
      } else {
        this.detail = null;
      }
    },
  },
  data: () => ({
    period: null,
    detail: null,
    displayed: [false, false, false],
    expand: [],
    FRI_TABS_HEIGHT,
  }),
};
</script>
